import SubmissionInfluencerProfile from './Profile'
export default SubmissionInfluencerProfile
